export default __webpack_public_path__ + "static/media/a009-1.2d3fff81.svg";